import { useThree } from "@react-three/fiber";
import { useEffect } from "react";
import { useCabinetStore } from "../../../../context/StoreContext";
import { useCanvasStore } from "../../../../hooks/useCanvasStore";
import LineComponent from "../../utils/Line";
import SizePill from "../../utils/SizePill";

export default function Dimensions() {
	const invalidate = useThree((selector) => selector.invalidate);
	const { showDimensions, fullScreen } = useCanvasStore();
	const { state } = useCabinetStore();

	const width = state.width / 1000;
	const height = state.height / 1000;
	const depth = state.depth / 1000;

	const extrude = 0.025;
	const fromGround = 0.05;
	const lineHeight = 0.025;

	useEffect(() => {
		showDimensions && invalidate();
	}, [invalidate, showDimensions]);

	if (!showDimensions) {
		return null;
	}

	return (
		<>
			{/* Width Line */}
			<LineComponent
				start={[0, height + fromGround + lineHeight, depth + extrude]}
				end={[0, height + fromGround - lineHeight, depth + extrude]}
			/>
			<LineComponent
				start={[0, height + fromGround, depth + extrude]}
				end={[width, height + fromGround, depth + extrude]}
			>
				<SizePill
					variant="width"
					size={state.width}
					position={{ x: width / 2, y: height + fromGround, z: depth + extrude }}
				/>
			</LineComponent>
			<LineComponent
				start={[width, height + fromGround + lineHeight, depth + extrude]}
				end={[width, height + fromGround - lineHeight, depth + extrude]}
			/>

			{/* Height Line */}
			<LineComponent
				start={[fromGround + width + lineHeight, 0, depth + extrude]}
				end={[fromGround + width - lineHeight, 0, depth + extrude]}
			/>
			<LineComponent
				start={[fromGround + width, 0, depth + extrude]}
				end={[fromGround + width, height, depth + extrude]}
			>
				<SizePill
					variant="height"
					size={state.height}
					position={{ x: fromGround + width, y: height / 2, z: depth + extrude }}
				/>
			</LineComponent>
			<LineComponent
				start={[fromGround + width + lineHeight, height, depth + extrude]}
				end={[fromGround + width - lineHeight, height, depth + extrude]}
			/>

			{/* Depth Line */}
			<LineComponent
				start={[-extrude, height + fromGround + lineHeight, 0]}
				end={[-extrude, height + fromGround - lineHeight, 0]}
			/>
			<LineComponent
				start={[-extrude, height + fromGround, 0]}
				end={[-extrude, height + fromGround, depth]}
			>
				<SizePill
					variant="depth"
					size={state.depth}
					position={{
						x: -extrude,
						y: height + fromGround,
						z: fullScreen ? depth + extrude : depth / 2,
					}}
				/>
			</LineComponent>
			<LineComponent
				start={[-extrude, height + fromGround + lineHeight, depth]}
				end={[-extrude, height + fromGround - lineHeight, depth]}
			/>
		</>
	);
}
